import React from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { useConfigureEverbridgeTokenModal } from './useConfigureEverbridgeTokenModal';
import './configureEverbridgeAuth.scss';

const ConfigureEverbridgeTokenModal = () => {
  const {
    handleAddButtonClick,
    showModel,
    handleClose,
    handleShow,
    setSecretKeyId,
    setAccessKeyId,
    setOrgId,
    secretKeyId,
    accessKeyId,
    organizationId,
    everbridgeTokenResponse,
    everbridgeGroupDetails
  } = useConfigureEverbridgeTokenModal();

  return (
    <>
      <span className='singlewire-btn'>
        <Button onClick={handleShow}>
          <span>
            {Boolean(everbridgeTokenResponse.userId)
              ? 'Reconfigure Token'
              : 'Configure Token'}
          </span>
        </Button>
      </span>

      <Modal
        show={showModel}
        onHide={handleClose}
        className='modal-container create-new-org-admin'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {Boolean(everbridgeTokenResponse.userId)
              ? 'Reconfigure Token'
              : 'Configure Token'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='add-group-container'>
            <div className='create-new-org-admin'>
              <Form.Group
                className='mb-3'
                controlId='exampleForm.ControlInput1'
              >
                <Form.Label>Access Key ID</Form.Label>
                <Form.Control
                  type='text'
                  placeholder={
                    Boolean(everbridgeTokenResponse.userId)
                      ? '************************'
                      : 'Add your access key id here....'
                  }
                  onChange={(e) => {
                    setAccessKeyId(e.target.value);
                  }}
                  required
                />
                <br />

                <Form.Label>Secret Access Key</Form.Label>
                <Form.Control
                  type='text'
                  placeholder={
                    Boolean(everbridgeTokenResponse.userId)
                      ? '************************'
                      : 'Add your secret access key here....'
                  }
                  onChange={(e) => {
                    setSecretKeyId(e.target.value);
                  }}
                  required
                />
                <br />

                <Form.Label>Organization Id</Form.Label>
                <Form.Control
                  type='text'
                  placeholder={
                    Boolean(everbridgeGroupDetails?.organizationId)
                      ? everbridgeGroupDetails?.organizationId
                      : 'Add your organization id here....'
                  }
                  onChange={(e) => {
                    setOrgId(e.target.value);
                  }}
                  required
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className='btn-style'
            disabled={!(secretKeyId.length > 0 && accessKeyId.length > 0 && organizationId.length > 0)}
            type='submit'
            onClick={handleAddButtonClick}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfigureEverbridgeTokenModal;
